import { useEffect, useState } from 'react';

function ContactPage() {
  const [message, setMessage] = useState('Loading...');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/message`)
      .then((res) => res.text())
      .then((data) => setMessage(data))
      .catch((err) => setMessage('Error: ' + err.message));
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-2">🍩 Our Contact</h1>
      <p>{message}</p>
    </div>
  );
}

export default ContactPage;
